import templateUrl from './resourceFormToolbar.html'

/**
 * Resource Form Toolbar component.
 *
 * Transcluded inside a {@link tmrResourceForm Resource Search Form} component.
 *
 * @example
 * <tmr-resource-form-toolbar
 *   op=""
 *   admin-title=""
 *   breadcrumbs=""
 *   resource-label=""
 *   submit-text=""
 *   submit-continue-text=""
 *   submit-disabled=""
 *   on-submit=""
 *   on-submit-continue=""
 * ></tmr-resource-form-toolbar>
 *
 * @type {ngComponent}
 * @prop {'add'|'edit'} op
 * @prop {string} admin-title
 * @prop {array=} breadcrumbs A list of breadcrumbs compatible with component {@link tmrBreadcrumbs}.
 * Defaults to resource list breadcrumbs
 * @prop {string} resource-label
 * @prop {string=} cancel-text The translation key of the form cancel button. Defaults to 'RESOURCEFORM.CANCEL'.
 * @prop {function} on-cancel The Cancel callback
 */
export const tmrResourceFormToolbar = {
  ngType: 'component',
  templateUrl,
  require: {
    resourceForm: '^^tmrResourceForm',
  },
  controller: 'tmrResourceFormToolbarController',
  bindings: {
    op: '<',
    adminTitle: '<',
    breadcrumbs: '<?',
    resourceLabel: '<',
    cancelText: '<',
    onCancel: '&',
  },
}

/**
 * Controller of component {@link tmrResourceFormToolbar}.
 *
 * @type {ngController}
 */
export class tmrResourceFormToolbarController {
  static ngType = 'controller'

  constructor($state) {
    'ngInject'
    Object.assign(this, { $state })
  }

  $onInit() {
    this.cancelText = this.cancelText ?? 'RESOURCEFORM.CANCEL'
    // Show the breadcrumb to resource view page only if it's defined.
    this.hasViewState =
      this.$state.current.parent && !this.$state.current.parent.abstract
    this.breadcrumbs =
      this.breadcrumbs ??
      (this.op == 'add' ? this.addBreadcrumbs() : this.editBreadcrumbs())
  }

  addBreadcrumbs() {
    return [
      { translate: this.adminTitle, sref: '^.list' },
      { translate: 'RESOURCEFORM.ADD' },
    ]
  }

  editBreadcrumbs() {
    return [
      { translate: this.adminTitle, sref: '^.^.list' },
      { title: this.resourceLabel, sref: this.hasViewState ? '^' : null },
      { translate: 'RESOURCEFORM.EDIT' },
    ]
  }
}
